export default "__VITE_ASSET__Db3qWB0$__"